import React from 'react';

export default function Error404() {
  return <h1 id="center-content">404 - Not Found</h1>;
}
